import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router";
import { EmptyState, SkeletonText } from "@astrum/ui";
import { api } from "../lib/api.js";

/** `/work/doc/:docId` — a link to a page (a mention, a search hit) opens its project's Docs tab. */
export function DocRedirect() {
  const { docId } = useParams();
  const [target, setTarget] = useState<string | null>(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    if (!docId) return;
    api
      .get<{ page: { projectId: string } }>(`/docs/${docId}`)
      .then((res) => setTarget(`/work/project/${res.page.projectId}?tab=docs&doc=${docId}`))
      .catch(() => setMissing(true));
  }, [docId]);

  if (target) return <Navigate to={target} replace />;
  if (missing) return <EmptyState title="Page not found" description="It may have been deleted, or you may not have access." />;
  return <SkeletonText lines={3} />;
}
